import { isAdminRole, isDeveloper, type Role, ROLES, seesRoadmapHours } from "@/lib/roles";

import type { RoleAccessId } from "./content";

/**
 * Which roles have each row of the docs' table of who sees what. Read from
 * the roles' own rules, so the docs change with them: everyone has the
 * connector, Home, the docs, their team's apps and their own switch per tool;
 * the admin roles add the admin pages (blocking someone included), the
 * history of the connector's issues with a note of their own, and the
 * roadmap with each month's progress; an owner and a developer see each
 * month's budget and change it (an owner for this month and later), and see
 * the roadmap's hours and days; a developer adds ideas straight to the
 * roadmap, reviews the triage, sets the items' effort, moves them and sees
 * their Linear tickets, takes on, resolves, ignores and reopens the
 * connector's issues, also from Claude, pauses a tool for everyone, and views
 * the dashboard as a colleague or a role.
 */
const HAS_ACCESS: Record<RoleAccessId, (role: Role) => boolean> = {
  connector: () => true,
  "start-and-docs": () => true,
  apps: () => true,
  "own-switches": () => true,
  "admin-pages": isAdminRole,
  "issue-notes": isAdminRole,
  roadmap: isAdminRole,
  "roadmap-budget": seesRoadmapHours,
  "roadmap-work": isDeveloper,
  "issue-work": isDeveloper,
  "pause-tools": isDeveloper,
  "view-as": isDeveloper,
};

/** The roles that have a row, in `ROLES` order. */
export function rolesWithAccess(row: RoleAccessId): Role[] {
  return ROLES.filter(HAS_ACCESS[row]);
}
